










































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Education extends Vue {
  timelineDotColor = "#00bcd4";

  educations = [
    {
      icon : "fas fa-university",
      time: "2011 - 2013",
      name : "Master of Science, eHealth",
      institute: "University of Applied Science 'FH Joanneum'",
      bulletpoints : ["Software Development", "Artificial Intelligence", "Business English", "Quality Management", "Process Management", "Business Intelligence"]
    },
    {
      icon : "fas fa-university",
      time: "2008 - 2011",
      name : "Bachelor of Science, eHealth",
      institute: "University of Applied Science 'FH Joanneum'",
      bulletpoints : ["Software Development", "Accounting", "Maths", "Physics", "Business English", "Healthcare", "Quality Management", "Process Management", "Medicine", "Risk Management"]
    },
    {
      icon : "fas fa-school",
      time: "2002 - 2007",
      name : "A Level (Matura), IT and Management",
      institute: "Higher Technical College 'HTBLA Kaindorf'",
      bulletpoints : ["Software Development", "Network Technology", "Maths", "English", "German", "Physics", "Accounting", "..."]
    },
  ];
}
